export function getLocalPart(email) {
  if (!email || typeof email !== 'string') return null;
  const at = email.indexOf('@');
  if (at <= 0) return email; // si no tiene @ o comienza con @, devuelve el entero
  return email.slice(0, at);
};
